<template>
  <div class="pds">
    <!-- KPIs -->
    <div class="pds__kpis">
      <div class="pds__kpi" v-for="k in kpis" :key="k.id">
        <div class="pds__kpi-top">
          <span class="pds__kpi-label">{{ k.label }}</span>
          <i :class="['fa-solid', k.icon]" :style="{ color: k.color }"></i>
        </div>
        <h3 class="pds__kpi-value" :style="k.id === 'pend_usd' ? 'color: var(--pd-red, #EF4444);' : ''">{{ k.value }}</h3>
        <p class="pds__kpi-sub">{{ k.sub }}</p>
      </div>
    </div>

    <!-- GRÁFICOS ROW 1 -->
    <div class="pds__charts-row">
      <div class="pds__chart-card">
        <div class="pds__card-head">
          <h3>CUMPLIMIENTO GLOBAL DE COMPRAS</h3>
          <p>Valor ingresado vs solicitado</p>
        </div>
        <div class="pds__chart-wrap pds__chart-wrap--sm" style="position: relative;">
          <canvas ref="chartCumplimiento"></canvas>
          <div class="pdm__gauge-text">
            <span>{{ globalFulfillment }}%</span>
            <small>Meta: 100%</small>
          </div>
        </div>
      </div>

      <div class="pds__chart-card" style="grid-column: span 2;">
        <div class="pds__card-head">
          <h3>CUMPLIMIENTO POR PROVEEDOR (TOP 10)</h3>
          <p>Progreso de recepción financiera (%)</p>
        </div>
        <div class="pds__chart-wrap pds__chart-wrap--sm">
          <canvas ref="chartSupplierFulfillment"></canvas>
        </div>
      </div>

      <div class="pds__chart-card">
        <div class="pds__card-head">
          <h3>ESTADO DE ÓRDENES</h3>
          <p>Proporción de OC</p>
        </div>
        <div class="pds__chart-wrap pds__chart-wrap--sm">
          <canvas ref="chartEstado"></canvas>
        </div>
      </div>
      <div class="pds__chart-card" style="grid-column: span 2;">
        <div class="pds__card-head">
          <h3>ÍNDICE DE PEDIDOS PERFECTOS</h3>
          <p>Tendencia de cumplimiento integral por periodo</p>
        </div>
        <div style="display: grid; grid-template-columns: 140px 1fr; gap: 16px; height: 180px;">
          <!-- Gauge -->
          <div class="pds__chart-wrap" style="height: 100% !important;">
             <canvas ref="chartPoiGauge"></canvas>
             <div class="pdm__gauge-text pdm__gauge-text--center">
               <span>{{ globalPoi }}%</span>
               <small style="color: #10B981">Meta: 100%</small>
             </div>
          </div>
          <!-- Line chart -->
          <div class="pds__chart-wrap" style="height: 100% !important;">
             <canvas ref="chartPoiLine"></canvas>
          </div>
        </div>
      </div>

      <div class="pds__chart-card" style="grid-column: span 2;">
        <div class="pds__card-head">
          <h3>INGRESOS VS PROGRAMADO (USD)</h3>
          <p>Comparativo mensual de recepción valorizada</p>
        </div>
        <div class="pds__chart-wrap pds__chart-wrap--sm">
          <canvas ref="chartEvolucion"></canvas>
        </div>
      </div>

      <div class="pds__chart-card" style="grid-column: span 2;">
        <div class="pds__card-head">
          <h3>MEJORES PROVEEDORES POR DESCUENTO</h3>
          <p>Top 5 proveedores con mayor porcentaje de descuento global</p>
        </div>
        <div class="pds__chart-wrap pds__chart-wrap--sm">
          <canvas ref="chartTopDiscount"></canvas>
        </div>
      </div>

      <div class="pds__chart-card" style="grid-column: span 2;">
        <div class="pds__card-head">
          <h3>AHORRO MENSUAL POR DESCUENTOS (USD)</h3>
          <p>Evolución de ahorros generados</p>
        </div>
        <div class="pds__chart-wrap pds__chart-wrap--sm">
          <canvas ref="chartAhorro"></canvas>
        </div>
      </div>
    </div>

    <!-- HORIZONTAL PIPELINE ROW -->
    <div class="pdm__pipeline-row" style="margin-bottom: 16px; width: 100%;">
      <div class="pds__chart-card pdm__pipeline-card">
         <div class="pdm__pipe-horizontal-wrap">
            <h3 class="pdm__pipe-h-title">PIPELINE DE ABASTECIMIENTO</h3>
            <div class="pdm__pipe-horizontal-items">
               <div v-for="(step, index) in pipelineHorizontal" :key="step.id" class="pdm__pipe-step-wrapper">
                  <div class="pdm__pipe-h-step-card">
                     <span class="pdm__pipe-h-label">{{ step.label }}</span>
                     <div class="pdm__pipe-h-value">
                        <i :class="['fa-solid', step.icon]"></i>
                        <strong>{{ step.value }}</strong>
                     </div>
                  </div>
                  <div class="pdm__pipe-h-arrow" v-if="index < pipelineHorizontal.length - 1">
                     <i class="fa-solid fa-arrow-right"></i>
                  </div>
               </div>
            </div>
         </div>
         <div class="pdm__pipe-h-value-box">
            <span class="pdm__pipe-h-title">VALOR PENDIENTE DE RECEPCIÓN (USD)</span>
            <strong class="pdm__pipe-h-big-val">${{ formatNumber(pendingAmount) }}</strong>
         </div>
      </div>
    </div>

    <!-- ROW 2 -->
    <div class="pdm__row-2">
      <!-- DONUT -->
      <div class="pdm__col-side">
        <div class="pds__chart-card">
          <div class="pds__card-head">
            <h3>COMPRAS POR RUBRO (USD)</h3>
            <p>Distribución de valor</p>
          </div>
          <div class="pds__chart-wrap pds__chart-wrap--sm">
            <canvas ref="chartFamilia"></canvas>
          </div>
        </div>
        
        <!-- COMPRADORES -->
        <div class="pds__chart-card">
          <div class="pds__card-head">
            <h3>TOP AHORRO POR COMPRADOR (USD)</h3>
            <p>Ahorro generado por gestor</p>
          </div>
          <div class="pds__chart-wrap pds__chart-wrap--sm">
            <canvas ref="chartCompradores"></canvas>
          </div>
        </div>
      </div>

      <!-- TABLA DE MATERIALES -->
      <div class="pdm__col-main">
        <DashboardTable
          title="Materiales Críticos por Ingresar"
          subtitle="Próximos vencimientos de fechas de compromiso"
          :items="pendingMaterials"
          :searchKeys="['ItemDescription', 'SupName', 'OrdDocumentNumber']"
          :itemsPerPage="8"
          :pagination="true"
          :showSearch="true"
          style="height: 100%; display: flex; flex-direction: column;"
        >
          <template #header>
            <tr>
              <th style="width: 25%">Material</th>
              <th style="width: 20%">Proveedor</th>
              <th style="width: 15%">F. Compromiso</th>
              <th style="width: 15%; text-align: right;">Cant. Pdte</th>
              <th style="width: 15%; text-align: right;">USD Pdte</th>
              <th style="width: 10%; text-align: center;">Estado</th>
            </tr>
          </template>
          <template #row="{ item }">
            <tr>
              <td><div class="pds__sku-cell"><strong>{{ item.ItemCode }}</strong><span>{{ item.ItemDescription }}</span></div></td>
              <td><div class="pds__sup-cell"><span>{{ item.SupName }}</span><small>OC: {{ item.OrdDocumentNumber }}</small></div></td>
              <td>{{ item.PromisedDate || 'N/A' }}</td>
              <td style="text-align: right; font-weight: 500;">{{ formatNumber(item.PendingQty) }}</td>
              <td style="text-align: right; font-weight: 600; color: var(--pd-red, #EF4444);">${{ formatNumber(item.PendingUSD) }}</td>
              <td style="text-align: center;">
                 <div class="pdm__status-dot" :class="item.statusColor" :title="item.daysDiff + ' días restantes'"></div>
              </td>
            </tr>
          </template>
        </DashboardTable>
      </div>
    </div>

  </div>
</template>

<script>
import Chart from 'chart.js/auto';
import DashboardTable from './DashboardTable.vue';
import _sOrderPurchase from "@/services/Logistics/OrderPurchaseService";

const SLATE = '#64748B';
const GREEN = '#10B981';
const RED = '#EF4444';
const BLUE = '#3B82F6';
const ORANGE = '#F97316';
const YELLOW = '#EAB308';
const PURPLE = '#8B5CF6';

export default {
  name: 'DashboardManagement',
  components: { DashboardTable },
  props: {
    dataset: { type: Array, default: () => [] },
    pipelineStats: { type: Object, default: () => null },
    isDark:  { type: Boolean, default: false }
  },
  data() {
    return {
      charts: {},
      categoriesMap: new Map()
    };
  },
  computed: {
    totalOrders() { return new Set(this.dataset.map(r => r.OrdDocumentNumber)).size || 0; },
    closedOrders() { return new Set(this.dataset.filter(r => this.isClosed(r)).map(r => r.OrdDocumentNumber)).size || 0; },
    openOrders() { return new Set(this.dataset.filter(r => !this.isClosed(r)).map(r => r.OrdDocumentNumber)).size || 0; },
    
    totalAmount() { return this.dataset.reduce((sum, r) => sum + (r.TotalAmount || 0), 0); },
    pendingAmount() { return this.dataset.reduce((sum, r) => sum + (r.PendingBalance || 0), 0); },
    enteredAmount() { return Math.max(0, this.totalAmount - this.pendingAmount); },
    
    globalFulfillment() {
       if (this.totalAmount === 0) return 0;
       return Math.round((this.enteredAmount / this.totalAmount) * 100);
    },
    
    pendingMaterialsCount() {
       return new Set(this.dataset.filter(r => (r.PendingBalance || 0) > 0).map(r => r.ItemCode)).size || 0;
    },
    
    kpis() {
      const savings = this.dataset.reduce((sum, r) => sum + (r.OddDiscountUsd || 0), 0);
      return [
        { id: 'oc_emitidas', label: 'OC EMITIDAS', icon: 'fa-file-invoice', color: SLATE, value: this.totalOrders, sub: 'Total' },
        { id: 'oc_cerradas', label: 'OC CERRADAS', icon: 'fa-check-circle', color: GREEN, value: this.closedOrders, sub: 'Completadas' },
        { id: 'oc_abiertas', label: 'OC ABIERTAS', icon: 'fa-lock-open', color: ORANGE, value: this.openOrders, sub: 'En Proceso' },
        { id: 'val_comprado', label: 'VALOR COMPRADO', icon: 'fa-dollar-sign', color: SLATE, value: this.formatUSD(this.totalAmount), sub: 'USD Total' },
        { id: 'pend_usd', label: 'PENDIENTE INGRESO', icon: 'fa-box-open', color: RED, value: this.formatUSD(this.pendingAmount), sub: 'USD Pendiente' },
        { id: 'mat_pend', label: 'MATERIALES PDTE.', icon: 'fa-boxes-stacked', color: SLATE, value: this.pendingMaterialsCount, sub: 'SKUs' },
        { id: 'cump_gen', label: 'CUMPLIMIENTO', icon: 'fa-bullseye', color: BLUE, value: `${this.globalFulfillment}%`, sub: 'Valor Ingresado' },
        { id: 'ahorro_usd', label: 'AHORRO (USD)', icon: 'fa-piggy-bank', color: GREEN, value: this.formatUSD(savings), sub: 'Descuentos' },
      ];
    },

    pipelineHorizontal() {
       const counts = { issued: 0, production: 0, received: 0, available: 0 };
       const uniqueOC = new Map();
       
       this.dataset.forEach(r => {
          if (!uniqueOC.has(r.OrdDocumentNumber)) uniqueOC.set(r.OrdDocumentNumber, r);
       });
       
       uniqueOC.forEach(r => {
          counts.issued++;
          
          if (r.OrdStatus == 5) {
             counts.production++;
          }
          
          const status = (r.OrdStatusName || '').toUpperCase();
          const hasBalance = (r.PendingBalance || 0) > 0;
          const enteredVal = (r.TotalAmount || 0) - (r.PendingBalance || 0);
          
          let isReceived = false;
          if (status.startsWith('CERR') || (enteredVal > 0 && !hasBalance)) {
             counts.received++;
             isReceived = true;
          }
          
          if (isReceived) {
             counts.available++;
          }
       });
       
       return [
          { id: 'solicitud', label: 'En Solicitud', icon: 'fa-file-lines', value: this.pipelineStats ? this.pipelineStats.RequirementsCount : 0 },
          { id: 'ocEmitida', label: 'OC Emitida', icon: 'fa-briefcase', value: counts.issued },
          { id: 'produccion', label: 'En Producción', icon: 'fa-gear', value: counts.production },
          { id: 'recepcionado', label: 'Recepcionado', icon: 'fa-warehouse', value: counts.received },
          { id: 'disponible', label: 'Disponible', icon: 'fa-check-circle', value: counts.available },
       ];
    },

    pendingMaterials() {
       const items = [];
       const today = new Date();
       today.setHours(0,0,0,0);
       
       this.dataset.filter(r => (r.PendingBalance || 0) > 0).forEach(r => {
          // Parse PromisedDate (DD/MM/YYYY)
          let daysDiff = 999;
          if (r.PromisedDate) {
             const parts = r.PromisedDate.split('/');
             if (parts.length === 3) {
                const prom = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
                const diffTime = prom - today;
                daysDiff = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
             }
          }
          
          let statusColor = 'pdm__dot--green'; // A tiempo (> 7 dias)
          if (daysDiff < 0) statusColor = 'pdm__dot--red'; // Vencido
          else if (daysDiff <= 7) statusColor = 'pdm__dot--yellow'; // Riesgo (0-7 dias)
          
          // Estimar Quantity pendiente basado en valor si no hay Qty precisa, 
          // pero asumimos que r.Quantity es la total y r.PendingBalance es el saldo USD.
          // Para mostrar cantidad pendiente exacta, calculamos Qty * (PendingBalance/TotalAmount)
          const pctPend = r.TotalAmount ? r.PendingBalance / r.TotalAmount : 1;
          const pendQty = Math.round((r.Quantity || 0) * pctPend);

          items.push({ ...r, PendingQty: pendQty, PendingUSD: r.PendingBalance, daysDiff, statusColor });
       });
       
       return items.sort((a, b) => a.daysDiff - b.daysDiff);
    },

    monthlyPoiData() {
       const map = new Map();
       const monthNames = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
       
       const today = new Date();
       const currentMonthKey = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2, '0')}`;

       this.dataset.forEach(r => {
          if (!r.OrdDate) return;
          const parts = r.OrdDate.split(' ')[0].split('/');
          if (parts.length === 3) {
             const monthKey = `${parts[2]}-${parts[1].padStart(2, '0')}`;
             
             // Filtrar meses futuros (por posibles errores de digitación en SAP)
             if (monthKey > currentMonthKey) return;

             const monthName = monthNames[parseInt(parts[1], 10) - 1];
             if (!map.has(monthKey)) {
                map.set(monthKey, { key: monthKey, label: monthName, totalLines: 0, perfectLines: 0, totalAmount: 0, enteredAmount: 0, savings: 0 });
             }
             const m = map.get(monthKey);
             m.totalLines++;
             
             const tot = r.TotalAmount || 0;
             const pend = r.PendingBalance || 0;
             
             m.totalAmount += tot;
             m.enteredAmount += Math.max(0, tot - pend);
             m.savings += (r.OddDiscountUsd || 0);
             
             if (!pend || pend <= 0) {
                m.perfectLines++;
             }
          }
       });
       return Array.from(map.values()).sort((a,b) => a.key.localeCompare(b.key));
    },

    globalPoi() {
       const data = this.monthlyPoiData;
       if (data.length === 0) return 0;
       let totalLines = 0;
       let perfectLines = 0;
       data.forEach(m => { totalLines += m.totalLines; perfectLines += m.perfectLines; });
       return totalLines ? Math.round((perfectLines / totalLines) * 100) : 0;
    }
  },
  watch: {
    dataset() { this.$nextTick(() => this.renderCharts()); },
    isDark() { this.$nextTick(() => this.renderCharts()); }
  },
  mounted() {
    this.fetchCategories();
    this.$nextTick(() => this.renderCharts());
  },
  beforeDestroy() {
    Object.values(this.charts).forEach(c => c && c.destroy());
  },
  methods: {
    async fetchCategories() {
       try {
          const res = await _sOrderPurchase.getCategory();
          if (res && res.data) {
             const map = new Map();
             res.data.forEach(c => {
                const code = c.Code || c.CategoryCode || c.CategoryName;
                const name = c.Name || c.CategoryName;
                if (code) map.set(code, name);
             });
             this.categoriesMap = map;
             this.renderFamilyChart();
          }
       } catch (err) {
          console.error("Error al obtener rubros:", err);
       }
    },
    isClosed(row) {
      const name = (row.OrdStatusName || '').toUpperCase();
      if (name.startsWith('CERR')) return true;
      if (row.OrdStatus == null) return false;
      return [3, 6, 8, 9].includes(Number(row.OrdStatus));
    },
    formatUSD(v) {
      if (v === undefined || v === null || isNaN(v)) return '$0';
      if (v >= 1_000_000) return `$${(v/1_000_000).toFixed(2)}M`;
      if (v >= 1_000)     return `$${Math.round(v/1_000)}K`;
      return `$${Number(v).toFixed(0)}`;
    },
    formatNumber(v) {
       return new Intl.NumberFormat('en-US').format(v || 0);
    },
    
    renderCharts() {
       this.renderGaugeChart();
       this.renderSupplierFulfillment();
       this.renderStatusChart();
       this.renderFamilyChart();
       this.renderPoiCharts();
       this.renderTopDiscountChart();
       this.renderAhorroChart();
       this.renderBuyerChart();
    },
    
    getChartColors(isDark) {
      return {
        text: isDark ? '#E2E8F0' : '#475569',
        textMuted: isDark ? '#94A3B8' : '#64748B',
        grid: isDark ? '#334155' : '#E2E8F0',
        bg: isDark ? '#1E293B' : '#F1F5F9'
      };
    },

    renderGaugeChart() {
       if (this.charts.cumplimiento) this.charts.cumplimiento.destroy();
       if (!this.$refs.chartCumplimiento) return;
       
       const c = this.getChartColors(this.isDark);
       const val = this.globalFulfillment;
       const left = Math.max(0, 100 - val);
       
       let color = GREEN;
       if (val < 50) color = RED;
       else if (val < 80) color = YELLOW;
       else if (val < 95) color = BLUE;
       
       this.charts.cumplimiento = new Chart(this.$refs.chartCumplimiento, {
          type: 'doughnut',
          data: {
             labels: ['Cumplido', 'Pendiente'],
             datasets: [{
                data: [val, left],
                backgroundColor: [color, c.bg],
                borderWidth: 0
             }]
          },
          options: {
             responsive: true, maintainAspectRatio: false,
             rotation: -90, circumference: 180, cutout: '75%',
             plugins: { legend: { display: false }, tooltip: { enabled: false } }
          }
       });
    },

    renderSupplierFulfillment() {
       if (this.charts.supplierFulfillment) this.charts.supplierFulfillment.destroy();
       if (!this.$refs.chartSupplierFulfillment) return;
       
       const supMap = new Map();
       this.dataset.forEach(r => {
          if (!supMap.has(r.SupName)) supMap.set(r.SupName, { total: 0, pending: 0 });
          const m = supMap.get(r.SupName);
          m.total += (r.TotalAmount || 0);
          m.pending += (r.PendingBalance || 0);
       });
       
       const arr = Array.from(supMap.entries()).map(([name, vals]) => {
          const entered = vals.total - vals.pending;
          const pct = vals.total > 0 ? Math.round((entered / vals.total) * 100) : 0;
          return { name, pct, total: vals.total };
       });
       
       arr.sort((a, b) => {
          if (b.pct !== a.pct) return b.pct - a.pct;
          return b.total - a.total;
       });
       const top = arr.slice(0, 10);
       const c = this.getChartColors(this.isDark);
       
       this.charts.supplierFulfillment = new Chart(this.$refs.chartSupplierFulfillment, {
          type: 'bar',
          data: {
             labels: top.map(x => x.name.substring(0, 15) + (x.name.length>15?'...':'')),
             datasets: [{
                label: '% Cumplimiento',
                data: top.map(x => x.pct),
                backgroundColor: top.map(x => (x.pct >= 95 ? GREEN : (x.pct >= 80 ? BLUE : (x.pct >= 50 ? YELLOW : RED)))),
                borderRadius: 4, maxBarThickness: 12
             }]
          },
          options: {
             indexAxis: 'y', responsive: true, maintainAspectRatio: false,
             scales: {
                x: { max: 100, ticks: { color: c.text, font: { size: 10 }, callback: v => v + '%' }, grid: { color: c.grid } },
                y: { ticks: { color: c.text, font: { size: 10 }, autoSkip: false }, grid: { display: false } }
             },
             plugins: { legend: { display: false }, tooltip: { callbacks: { label: (ctx) => `Cumplimiento: ${ctx.raw}%` } } }
          }
       });
    },

    renderStatusChart() {
       if (this.charts.estado) this.charts.estado.destroy();
       if (!this.$refs.chartEstado) return;
       
       const map = new Map();
       this.dataset.forEach(r => {
          const st = r.OrdStatusName || 'Sin Estado';
          map.set(st, (map.get(st)||0) + 1);
       });
       
       const labels = Array.from(map.keys());
       const data = Array.from(map.values());
       const c = this.getChartColors(this.isDark);
       
       this.charts.estado = new Chart(this.$refs.chartEstado, {
          type: 'doughnut',
          data: {
             labels,
             datasets: [{ data, backgroundColor: [BLUE, GREEN, ORANGE, RED, SLATE, YELLOW, PURPLE], borderWidth: 1, borderColor: c.bg }]
          },
          options: {
             responsive: true, maintainAspectRatio: false, cutout: '65%',
             plugins: { legend: { position: 'bottom', labels: { color: c.text, font: { size: 10 }, boxWidth: 10, padding: 8 } } }
          }
       });
    },

    renderFamilyChart() {
       if (this.charts.familia) this.charts.familia.destroy();
       if (!this.$refs.chartFamilia) return;
       
       const map = new Map();
       this.dataset.forEach(r => {
          let cat = 'OTROS';
          if (r.CategoryCode) {
             cat = this.categoriesMap.get(r.CategoryCode) || r.CategoryCode;
          }
          cat = cat.toUpperCase();
          map.set(cat, (map.get(cat)||0) + (r.TotalAmount||0));
       });
       
       const sorted = Array.from(map.entries()).sort((a,b) => b[1] - a[1]);
       
       let finalEntries = sorted.slice(0, 5);
       if (sorted.length > 5) {
          const sumOtros = sorted.slice(5).reduce((acc, curr) => acc + curr[1], 0);
          if (sumOtros > 0) finalEntries.push(['OTROS', sumOtros]);
       }
       
       const labels = finalEntries.map(x => x[0]);
       const data = finalEntries.map(x => x[1]);
       const c = this.getChartColors(this.isDark);
       const colors = { EMBALAJE: GREEN, EMPAQUE: YELLOW, PARIHUELA: ORANGE, OTRO: SLATE, OTROS: SLATE };
       
       this.charts.familia = new Chart(this.$refs.chartFamilia, {
          type: 'bar',
          data: {
             labels,
             datasets: [{ 
                data, 
                backgroundColor: labels.map(x => colors[x.toUpperCase()] || GREEN), 
                borderRadius: 4 
             }]
          },
          options: {
             indexAxis: 'y',
             responsive: true, maintainAspectRatio: false,
             plugins: { 
                legend: { display: false },
                tooltip: { callbacks: { label: (ctx) => ` $${this.formatNumber(ctx.raw)}` } }
             },
             scales: {
                x: { ticks: { color: c.textMuted, font: { size: 9 }, callback: v => v >= 1000 ? `$${(v/1000).toFixed(0)}K` : `$${v}` }, grid: { color: c.grid } },
                y: { ticks: { color: c.text, font: { size: 10 } }, grid: { display: false } }
             }
          }
       });
    },

    renderBuyerChart() {
       if (this.charts.compradores) this.charts.compradores.destroy();
       if (!this.$refs.chartCompradores) return;
       
       const map = new Map();
       this.dataset.forEach(r => {
          let buyer = r.UsrName || 'SIN ASIGNAR';
          buyer = buyer.trim().toUpperCase();
          map.set(buyer, (map.get(buyer)||0) + (r.OddDiscountUsd||0));
       });
       
       const sorted = Array.from(map.entries()).sort((a,b) => b[1] - a[1]);
       
       let finalEntries = sorted.slice(0, 5);
       if (sorted.length > 5) {
          const sumOtros = sorted.slice(5).reduce((acc, curr) => acc + curr[1], 0);
          if (sumOtros > 0) finalEntries.push(['OTROS', sumOtros]);
       }
       
       const labels = finalEntries.map(x => x[0].substring(0, 25) + (x[0].length>25?'...':''));
       const data = finalEntries.map(x => x[1]);
       const c = this.getChartColors(this.isDark);
       
       this.charts.compradores = new Chart(this.$refs.chartCompradores, {
          type: 'bar',
          data: {
             labels,
             datasets: [{ 
                data, 
                backgroundColor: '#10B981', // Verde para indicar ahorro
                borderRadius: 4 
             }]
          },
          options: {
             indexAxis: 'y',
             responsive: true, maintainAspectRatio: false,
             plugins: { 
                legend: { display: false },
                tooltip: { callbacks: { label: (ctx) => ` $${this.formatNumber(ctx.raw)}` } }
             },
             scales: {
                x: { ticks: { color: c.textMuted, font: { size: 9 }, callback: v => v >= 1000 ? `$${(v/1000).toFixed(0)}K` : `$${v}` }, grid: { color: c.grid } },
                y: { ticks: { color: c.text, font: { size: 10 } }, grid: { display: false } }
             }
          }
       });
    },

    renderPoiCharts() {
      const c = this.getChartColors(this.isDark);
      
      if (this.charts.poiGauge) this.charts.poiGauge.destroy();
      const poi = this.globalPoi;
      this.charts.poiGauge = new Chart(this.$refs.chartPoiGauge, {
          type: 'doughnut',
          data: {
            labels: ['Perfectos', 'Con Saldo'],
            datasets: [{ data: [poi, 100 - poi], backgroundColor: [GREEN, c.bg], borderWidth: 0 }]
          },
          options: { 
             responsive: true, maintainAspectRatio: false, 
             cutout: '75%',
             plugins: { legend: { display: false }, tooltip: { enabled: false } } 
          }
      });

      if (this.charts.poiLine) this.charts.poiLine.destroy();
      const mData = this.monthlyPoiData;
      this.charts.poiLine = new Chart(this.$refs.chartPoiLine, {
          type: 'line',
          data: {
             labels: mData.map(m => m.label),
             datasets: [{
                label: 'Índice POI (%)', data: mData.map(m => m.totalLines ? Math.round((m.perfectLines / m.totalLines) * 100) : 0),
                borderColor: GREEN, backgroundColor: 'transparent',
                borderWidth: 2, pointBackgroundColor: GREEN, pointRadius: 4, tension: 0.3
             }]
          },
          options: {
             responsive: true, maintainAspectRatio: false,
             plugins: { legend: { display: false }, tooltip: { callbacks: { label: (ctx) => ` ${ctx.raw}%` } } },
             scales: {
                y: { min: 0, max: 100, ticks: { color: c.textMuted, font: { size: 9 }, callback: v => v + '%' }, grid: { color: c.grid } },
                x: { ticks: { color: c.textMuted, font: { size: 10 } }, grid: { display: false } }
             }
          }
      });

      if (this.charts.evolucion) this.charts.evolucion.destroy();
      this.charts.evolucion = new Chart(this.$refs.chartEvolucion, {
          type: 'bar',
          data: {
             labels: mData.map(m => m.label),
             datasets: [
                {
                   label: 'Programado', data: mData.map(m => m.totalAmount),
                   backgroundColor: BLUE, borderRadius: 2, barPercentage: 0.6, categoryPercentage: 0.8
                },
                {
                   label: 'Ingresado', data: mData.map(m => m.enteredAmount),
                   backgroundColor: GREEN, borderRadius: 2, barPercentage: 0.6, categoryPercentage: 0.8
                }
             ]
          },
          options: {
             responsive: true, maintainAspectRatio: false,
             plugins: { 
                legend: { display: true, position: 'top', align: 'start', labels: { color: c.textMuted, usePointStyle: true, boxWidth: 6, font: { size: 10 } } } 
             },
             scales: {
                y: { 
                   beginAtZero: true, 
                   ticks: { color: c.textMuted, font: { size: 9 }, callback: v => '$' + (v/1000).toFixed(0) + 'K' }, 
                   grid: { color: c.grid } 
                },
                x: { ticks: { color: c.textMuted, font: { size: 10 } }, grid: { display: false } }
             }
          }
      });
    },

    renderTopDiscountChart() {
       if (this.charts.topDiscount) this.charts.topDiscount.destroy();
       if (!this.$refs.chartTopDiscount) return;
       
       const supMap = new Map();
       const uniqueOC = new Map();
       this.dataset.forEach(r => {
          if (!uniqueOC.has(r.OrdDocumentNumber)) {
             uniqueOC.set(r.OrdDocumentNumber, { 
                supName: r.SupName, 
                discount: r.OrdDiscountPercentage || 0,
                amount: r.TotalAmount || 0
             });
          }
       });

       uniqueOC.forEach(oc => {
          if (!supMap.has(oc.supName)) supMap.set(oc.supName, { totalDisc: 0, count: 0, totalAmount: 0 });
          const m = supMap.get(oc.supName);
          m.totalDisc += (oc.discount * oc.amount);
          m.totalAmount += oc.amount;
          m.count++;
       });
       
       const arr = Array.from(supMap.entries()).map(([name, vals]) => {
          const avgPct = vals.totalAmount > 0 ? (vals.totalDisc / vals.totalAmount) : 0;
          return { name, pct: avgPct };
       }).filter(x => x.pct > 0);
       
       arr.sort((a, b) => b.pct - a.pct);
       const top = arr.slice(0, 5);
       
       const c = this.getChartColors(this.isDark);
       this.charts.topDiscount = new Chart(this.$refs.chartTopDiscount, {
          type: 'bar',
          data: {
             labels: top.map(x => x.name.substring(0, 15) + (x.name.length>15?'...':'')),
             datasets: [{
                label: 'Descuento Global (%)',
                data: top.map(x => x.pct.toFixed(2)),
                backgroundColor: '#10B981',
                borderRadius: 4,
                barThickness: 20
             }]
          },
          options: {
             indexAxis: 'y',
             responsive: true, maintainAspectRatio: false,
             plugins: { legend: { display: false }, tooltip: { callbacks: { label: (ctx) => ` ${ctx.raw}%` } } },
             scales: {
                x: { ticks: { color: c.textMuted, font: { size: 10 }, callback: v => v + '%' }, grid: { color: c.grid } },
                y: { ticks: { color: c.textMuted, font: { size: 10 } }, grid: { display: false } }
             }
          }
       });
    },

    renderAhorroChart() {
       if (this.charts.ahorro) this.charts.ahorro.destroy();
       if (!this.$refs.chartAhorro) return;
       
       const mData = this.monthlyPoiData;
       const c = this.getChartColors(this.isDark);
       
       this.charts.ahorro = new Chart(this.$refs.chartAhorro, {
          type: 'line',
          data: {
             labels: mData.map(x => x.label), // Labels de meses cortos (Ene, Feb)
             datasets: [{
                label: 'Ahorro (USD)',
                data: mData.map(x => (x.savings || 0).toFixed(2)),
                borderColor: '#10B981', backgroundColor: 'rgba(16, 185, 129, 0.1)',
                borderWidth: 2, pointBackgroundColor: '#10B981', pointRadius: 4, tension: 0.3, fill: true
             }]
          },
          options: {
             responsive: true, maintainAspectRatio: false,
             plugins: { legend: { display: false }, tooltip: { callbacks: { label: (ctx) => ` $${ctx.raw}` } } },
             scales: {
                y: { beginAtZero: true, ticks: { color: c.textMuted, font: { size: 10 }, callback: v => '$' + (v/1000).toFixed(0) + 'K' }, grid: { color: c.grid } },
                x: { ticks: { color: c.textMuted, font: { size: 10 } }, grid: { display: false } }
             }
          }
       });
    }
  }
};
</script>

<style scoped>
.pds { display: flex; flex-direction: column; gap: 20px; font-family: 'Inter', sans-serif; padding-bottom: 20px; }

/* KPIs */
.pds__kpis { display: grid !important; grid-template-columns: repeat(8, 1fr) !important; gap: 16px !important; }
@media(max-width: 1400px) { .pds__kpis { grid-template-columns: repeat(4, 1fr) !important; } }
@media(max-width: 768px) { .pds__kpis { grid-template-columns: repeat(2, 1fr) !important; } }

.pds__kpi { background: var(--pd-card-bg, #fff) !important; border: 1px solid var(--pd-border, #E2E8F0) !important; border-radius: 12px !important; padding: 16px !important; box-shadow: 0 2px 4px rgba(0,0,0,0.02) !important; transition: transform 0.2s !important; display: flex !important; flex-direction: column !important; }
.pds__kpi-top { display: flex !important; justify-content: space-between !important; align-items: center !important; margin-bottom: 8px !important; }
.pds__kpi-label { font-size: 11px !important; font-weight: 600 !important; color: var(--pd-text-muted, #64748B) !important; text-transform: uppercase !important; letter-spacing: 0.5px !important; }
.pds__kpi-value { font-size: 24px !important; font-weight: 800 !important; color: var(--pd-text, #1E293B) !important; margin: 0 !important; line-height: 1.2 !important; }
.pds__kpi-sub { font-size: 11px !important; color: var(--pd-text-muted, #64748B) !important; margin: 4px 0 0 0 !important; font-weight: 500 !important; }

/* Cards & Charts */
.pds__charts-row { display: grid !important; grid-template-columns: repeat(4, 1fr) !important; gap: 16px !important; align-items: start !important; }
.pds__chart-card { background: var(--pd-card-bg, #fff) !important; border: 1px solid var(--pd-border, #E2E8F0) !important; border-radius: 12px !important; padding: 16px !important; box-shadow: 0 2px 4px rgba(0,0,0,0.02) !important; min-height: 0 !important; min-width: 0 !important; overflow: hidden !important; }
.pds__card-head h3 { font-size: 12px !important; font-weight: 700 !important; color: var(--pd-text, #1E293B) !important; margin: 0 0 4px 0 !important; text-transform: uppercase !important; letter-spacing: 0.5px !important; }
.pds__card-head p { font-size: 11px !important; color: var(--pd-text-muted, #64748B) !important; margin: 0 0 16px 0 !important; }
.pds__chart-wrap { position: relative !important; width: 100% !important; height: 250px !important; min-height: 0 !important; min-width: 0 !important; overflow: hidden !important; }
.pds__chart-wrap--sm { height: 180px !important; }

/* Gauge Center Text */
.pdm__gauge-text { position: absolute !important; bottom: 0 !important; left: 0 !important; width: 100% !important; display: flex !important; flex-direction: column !important; align-items: center !important; justify-content: center !important; pointer-events: none !important; }
.pdm__gauge-text--center { top: 0 !important; height: 100% !important; }
.pdm__gauge-text span { font-size: 32px !important; font-weight: 800 !important; color: var(--pd-text, #1E293B) !important; line-height: 1 !important; }
.pdm__gauge-text small { font-size: 11px !important; color: var(--pd-text-muted, #64748B) !important; margin-top: 4px !important; font-weight: 500 !important; }

/* Row 2 layout */
.pdm__row-2 { display: grid !important; grid-template-columns: 350px 1fr !important; gap: 16px !important; }
.pdm__col-side { display: flex !important; flex-direction: column !important; gap: 16px !important; }
.pdm__col-main { min-width: 0 !important; }

/* Horizontal Pipeline Modern */
.pdm__pipeline-card {
    display: flex !important; 
    justify-content: flex-start !important; 
    align-items: center !important; 
    padding: 16px 24px !important; 
    overflow-x: auto !important;
    gap: 32px !important; 
    flex-wrap: wrap !important;
}
.pdm__pipe-horizontal-wrap { flex: 1 1 auto !important; display: flex !important; flex-direction: column !important; min-width: 300px !important; }
.pdm__pipe-h-title { font-size: 11px !important; font-weight: 700 !important; color: var(--pd-text, #1E293B) !important; margin: 0 0 12px 0 !important; text-transform: uppercase !important; letter-spacing: 0.5px !important; }
.pdm__pipe-horizontal-items { display: flex !important; align-items: center !important; gap: 14px !important; flex-wrap: wrap !important; }

.pdm__pipe-step-wrapper {
   display: flex !important;
   align-items: center !important;
   gap: 14px !important;
}

.pdm__pipe-h-step-card { 
   background: transparent !important; 
   border: 1px solid rgba(148, 163, 184, 0.3) !important; 
   border-radius: 8px !important; 
   padding: 10px 16px !important; 
   display: flex !important; 
   flex-direction: column !important; 
   align-items: center !important; 
   gap: 6px !important; 
   min-width: 100px !important; 
   transition: all 0.2s ease !important;
}
.pdm__pipe-h-step-card:hover { border-color: rgba(148, 163, 184, 0.8) !important; background: rgba(148, 163, 184, 0.05) !important; }

.pdm__pipe-h-label { font-size: 11px !important; font-weight: 600 !important; color: var(--pd-text, #E2E8F0) !important; }

.pdm__pipe-h-value { display: flex !important; align-items: center !important; justify-content: center !important; gap: 8px !important; width: 100% !important; }
.pdm__pipe-h-value i { font-size: 14px !important; color: rgba(148, 163, 184, 0.7) !important; }
.pdm__pipe-h-value strong { font-size: 18px !important; font-weight: 700 !important; color: var(--pd-text, #F8FAFC) !important; }

.pdm__pipe-h-arrow { color: rgba(148, 163, 184, 0.5) !important; font-size: 14px !important; display: flex !important; align-items: center !important; padding-top: 12px !important; }

.pdm__pipe-h-value-box { flex: 0 0 auto !important; border-left: 1px solid rgba(148, 163, 184, 0.2) !important; padding-left: 32px !important; display: flex !important; flex-direction: column !important; justify-content: center !important; height: 100% !important; }
.pdm__pipe-h-big-val { font-size: 32px !important; font-weight: 800 !important; color: var(--pd-text, #F8FAFC) !important; margin-top: 4px !important; }

@media (max-width: 900px) {
    .pdm__pipe-horizontal-items {
        flex-direction: column !important;
        align-items: stretch !important;
    }
    .pdm__pipe-step-wrapper {
        flex-direction: column !important;
        width: 100% !important;
    }
    .pdm__pipe-h-step-card {
        width: 100% !important;
        max-width: 100% !important;
    }
    .pdm__pipe-h-arrow {
        padding: 4px 0 !important;
        transform: rotate(90deg) !important;
    }
    .pdm__pipe-h-value-box {
        border-left: none !important;
        border-top: 1px solid rgba(148, 163, 184, 0.2) !important;
        padding-left: 0 !important;
        padding-top: 16px !important;
        width: 100% !important;
    }
}

/* Table cells */
.pds__sku-cell { display: flex !important; flex-direction: column !important; }
.pds__sku-cell strong { font-size: 11px !important; color: var(--pd-text, #1E293B) !important; }
.pds__sku-cell span { font-size: 10px !important; color: var(--pd-text-muted, #64748B) !important; white-space: nowrap !important; overflow: hidden !important; text-overflow: ellipsis !important; max-width: 200px !important; }
.pds__sup-cell { display: flex !important; flex-direction: column !important; }
.pds__sup-cell span { font-size: 11px !important; font-weight: 600 !important; color: var(--pd-text, #334155) !important; }
.pds__sup-cell small { font-size: 10px !important; color: var(--pd-text-muted, #94A3B8) !important; }

/* Dots */
.pdm__status-dot { width: 12px !important; height: 12px !important; border-radius: 50% !important; display: inline-block !important; box-shadow: inset 0 0 0 1px rgba(0,0,0,0.1) !important; }
.pdm__dot--green { background: #10B981 !important; }
.pdm__dot--yellow { background: #F59E0B !important; }
.pdm__dot--red { background: #EF4444 !important; }

@media(max-width: 1200px) {
  .pds__charts-row { grid-template-columns: repeat(2, 1fr) !important; }
  .pds__chart-card[style*="grid-column: span 2;"] { grid-column: span 1 !important; }
  .pdm__row-2 { grid-template-columns: 1fr !important; }
}
@media(max-width: 768px) {
  .pds__charts-row { grid-template-columns: 1fr !important; }
}
</style>
